import AllInboxIcon from '@material-ui/icons/AllInbox';
import AlbaranList from './AlbaranList';
import AlbaranCreate from './AlbaranCreate';

export default {
    list: AlbaranList,
    create: AlbaranCreate,
    icon: AllInboxIcon,
};
